import React from "react";
import './card.css'

const Card = () => {
    return (
        <>
            <ul class="cards">
                <li>
                    <a href="" class="card ">
                        {/* <img src="https://i.imgur.com/oYiTqum.jpg" class="card__image" alt="" /> */}
                        <img class="card__image" src="urboncoBank/card/goldLoan.jpg" alt="" />
                        <div class="card__overlay ">
                            <div class="card__header  ">
                                <svg class="card__arc" xmlns="http://www.w3.org/2000/svg"><path /></svg>
                                <img class="card__thumb" src="urboncoBank/card/goldLoan.jpg" alt="" />
                                <div class="card__header-text  ">
                                    <h3 class="card__title">Gold Loan</h3>
                                    <span class="card__status">1 hour ago</span>
                                </div>
                            </div>
                            <p class="card__description ">Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, blanditiis?</p>
                        </div>
                    </a>
                </li>
                <li>
                    <a href="" class="card">
                    <img class="card__image " src="urboncoBank/card/carLoan.jpg" alt="" />
                        <div class="card__overlay">
                            <div class="card__header">
                                <svg class="card__arc" xmlns="http://www.w3.org/2000/svg"><path /></svg>
                                <img class="card__thumb" src="urboncoBank/card/carLoan.jpg" alt="" />
                                <div class="card__header-text">
                                    <h3 class="card__title">Car Loan</h3>
                                    <span class="card__status">3 hours ago</span>
                                </div>
                            </div>
                            <p class="card__description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, blanditiis?</p>
                        </div>
                    </a>
                </li>
               
                <li>
                    <a href="" class="card">
                    <img class="card__image" src="urboncoBank/card/homeLoan.jpg" alt="" />
                        <div class="card__overlay">
                            <div class="card__header">
                                <svg class="card__arc" xmlns="http://www.w3.org/2000/svg"><path /></svg>
                                <img class="card__thumb" src="urboncoBank/card/homeLoan.jpg" alt="" />
                                <div class="card__header-text">
                                    <h3 class="card__title">Home Loan</h3>
                                    <span class="card__status">3 hours ago</span>
                                </div>
                            </div>
                            <p class="card__description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, blanditiis?</p>
                        </div>
                    </a>
                </li>
                <li>
                    <a href="" class="card h-80">
                    <img class="card__image" src="urboncoBank/card/pexels-energepiccom-2988232.jpg" alt="" />
                        <div class="card__overlay">
                            <div class="card__header">
                                <svg class="card__arc" xmlns="http://www.w3.org/2000/svg"><path /></svg>
                                <img class="card__thumb"  src="urboncoBank/card/pexels-energepiccom-2988232.jpg" alt="" />
                                <div class="card__header-text">
                                    <h3 class="card__title">Personal Loan</h3>
                                    <span class="card__status">3 hours ago</span>
                                </div>
                            </div>
                            <p class="card__description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, blanditiis?</p>
                        </div>
                    </a>
                </li>
            </ul>

        </>
    )
}

export default Card ;